export const ja = {
  title: {
    preview_mode: "プレビューモード",
    test_mode_on: "テストモードON"
  },
  sending: "送信中 ...",
  registration_process_failed: "登録処理に失敗しました。",
  it_is_possible_that_multiple_windows_or_tabs_are_currently_in_operation: "ウィンドウやタブを複数開いて操作された可能性があります。",
  please_check_your_browser_and_then_try_again: "お手数ですがご確認のうえ、再度お手続きください。"
};
